import {NgModule} from '@angular/core';
import {SharedModule} from '../../../shared/shared.module';
import {LoginComponent} from './login.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [SharedModule],
  exports: [LoginComponent],
  providers: []
})
export class LoginModule {

}
